import React, { useEffect, useRef, useState } from "react";

// 상단 바의 학생 이름을 누르면 여는 작은 메뉴. 지금은 '앱 설치' 한 줄뿐이다(2026-11-02, 대표 요청으로 띠 대신 숨김).
// 설치한 앱은 public/index.html 이 만든 manifest 로 이 학생의 session 주소에서 열린다.
// 크롬·삼성 인터넷은 설치 창(beforeinstallprompt)을 바로 띄우고, 아이폰 사파리·앱 안 브라우저는 방법을 한 줄로 보여 준다.
// 이미 설치한 앱으로 열었으면 이름은 누를 수 없는 글자로 둔다.
const isInstalledApp = () => {
  try {
    return window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
  } catch (error) {
    return false;
  }
};

const userAgent = () => (window.navigator.userAgent || "").toLowerCase();
const isIphone = () => /iphone|ipad|ipod/.test(userAgent());
const isInAppBrowser = () => /kakaotalk|naver|instagram|fban|fbav|line\//.test(userAgent());

const installGuideText = () => {
  if (isInAppBrowser()) return "크롬이나 사파리로 열면 설치할 수 있어요";
  if (isIphone()) return "공유 → 홈 화면에 추가";
  return "브라우저 메뉴 → 앱 설치";
};

const DownloadIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" className="student-nav__install-icon">
    <path
      d="M12 4v11m0 0-4.5-4.5M12 15l4.5-4.5M5 19.5h14"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const AppInstallMenu = ({ children }) => {
  const [installPrompt, setInstallPrompt] = useState(() => window.deferredInstallPrompt || null);
  const [isInstalled, setIsInstalled] = useState(isInstalledApp);
  const [isOpen, setIsOpen] = useState(false);
  const [isGuideOpen, setIsGuideOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleBeforeInstallPrompt = (event) => {
      event.preventDefault();
      setInstallPrompt(event);
    };
    const handleInstalled = () => setIsInstalled(true);
    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    window.addEventListener("appinstalled", handleInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
      window.removeEventListener("appinstalled", handleInstalled);
    };
  }, []);

  // 메뉴 밖을 누르면 닫는다
  useEffect(() => {
    if (!isOpen) return undefined;
    const closeOnOutsideClick = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) setIsOpen(false);
    };
    document.addEventListener("mousedown", closeOnOutsideClick);
    return () => document.removeEventListener("mousedown", closeOnOutsideClick);
  }, [isOpen]);

  if (isInstalled) return <>{children}</>;

  const handleInstall = async () => {
    if (!installPrompt) {
      setIsGuideOpen((previous) => !previous);
      return;
    }
    installPrompt.prompt();
    const choice = await installPrompt.userChoice;
    // 한 번 쓴 신호는 다시 못 쓴다
    window.deferredInstallPrompt = null;
    setInstallPrompt(null);
    setIsOpen(false);
    if (choice && choice.outcome === "accepted") setIsInstalled(true);
  };

  return (
    <div ref={containerRef} className="student-nav__menu">
      <button
        type="button"
        className="student-nav__menu-trigger"
        onClick={() => {
          setIsOpen((previous) => !previous);
          setIsGuideOpen(false);
        }}
      >
        {children}
      </button>
      {isOpen && (
        <div className="student-nav__menu-dropdown">
          <button type="button" className="student-nav__menu-item" onClick={handleInstall}>
            <DownloadIcon />
            앱 설치
          </button>
          {isGuideOpen && <div className="student-nav__install-guide">{installGuideText()}</div>}
        </div>
      )}
    </div>
  );
};

export default AppInstallMenu;
